import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddDepartmentActions from './add-department.actions';

export const addDepartmentFeatureKey = 'addDepartment';

export interface AddDepartmentState {
   callState: CallState;
}

export const initialState: AddDepartmentState = {
   callState: LoadingState.Init,
};

const addDepartmentReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddDepartmentActions.createDepartment, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddDepartmentActions.createDepartmentSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddDepartmentActions.createDepartmentFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddDepartmentState | undefined, action: Action) {
   return addDepartmentReducer(state, action);
}
